import { getLastUsedPasskeyCredential } from './passkey-login-preference';

const DISMISSAL_MS = 30 * 24 * 60 * 60 * 1000;

type PasskeyOfferRecord = { dismissedAt?: number; onThisBrowser?: boolean };

const recordKey = (userId: string) => `gamma.passkey-offer.v1.${userId}`;

const readRecord = (userId: string): PasskeyOfferRecord => {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(recordKey(userId)) ?? '{}');
    return typeof parsed === 'object' && parsed !== null ? (parsed as PasskeyOfferRecord) : {};
  } catch {
    return {};
  }
};

const writeRecord = (userId: string, record: PasskeyOfferRecord): void => {
  try {
    localStorage.setItem(recordKey(userId), JSON.stringify({ ...readRecord(userId), ...record }));
  } catch {
    return;
  }
};

// Module memory, not storage: the offer belongs to the log in that requested it, not to a reload.
let offerRequested = false;

export const requestPasskeyOffer = (): void => {
  offerRequested = true;
};

export const hasPasskeyOffer = (): boolean => offerRequested;

export const takePasskeyOffer = (): boolean => {
  const requested = offerRequested;
  offerRequested = false;
  return requested;
};

// shortcut: the last-used credential is not tied to a Gamma user, so any passkey used here hides the offer for every account on this browser.
export const isPasskeyOfferDue = (userId: string, now = Date.now()): boolean => {
  if (getLastUsedPasskeyCredential()) return false;
  const { dismissedAt, onThisBrowser } = readRecord(userId);
  if (onThisBrowser) return false;
  return typeof dismissedAt !== 'number' || now - dismissedAt >= DISMISSAL_MS;
};

export const dismissPasskeyOffer = (userId: string, now = Date.now()): void => {
  writeRecord(userId, { dismissedAt: now });
};

export const markPasskeyOnThisBrowser = (userId: string): void => {
  writeRecord(userId, { onThisBrowser: true });
};
